module.exports = __webpack_public_path__ + "static/media/stu_and_remmy3.190a18f7.jpg";